import { render, staticRenderFns } from "./IconMailDelete.vue?vue&type=template&id=0c2b3b0b&"
var script = {}
import style0 from "./IconMailDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2b3b0b')) {
      api.createRecord('0c2b3b0b', component.options)
    } else {
      api.reload('0c2b3b0b', component.options)
    }
    module.hot.accept("./IconMailDelete.vue?vue&type=template&id=0c2b3b0b&", function () {
      api.rerender('0c2b3b0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconMailDelete.vue"
export default component.exports